<template>
  <fieldset class="step step--8">
    <Section :title="stepTitle">
      <CertificationFormGroup name="applicantComments" :can-moderate="false">
        <TextareaControl
          id="applicantComments"
          v-model="form.applicantComments"
          label="Uwagi zgłaszającego"
          number="1"
          :disabled="formDisabled"
        />
      </CertificationFormGroup>
    </Section>
  </fieldset>
</template>

<script>
import BaseCertificationFormStep from "@/components/Base/Certification/BaseCertificationFormStep";
import TextareaControl from "@/components/Controls/TextareaControl";

export default {
  name: "CertificationFormStep8",
  components: {
    TextareaControl
  },
  extends: BaseCertificationFormStep
};
</script>
